<div class="outer-container">
  <span class="currentStatusTitile">Alert</span>
  <div class="console-container">
    <div class="input-wrapper">
      <div class="row">
        <p>
          You already have an active session elsewhere. Click 'Yes' to start a new session here, or 'No' to keep the other session active.
        </p>
      </div>
    </div>
    <div class="bottom-line"></div>
    <div class="text-center mt-2">
      <button class="main-btn" (click)="continue()">
        <span>Yes</span>
      </button>
      <button class="outline-btn ms-2" (click)="logout()">
        <span>No</span>
      </button>
    </div>
  </div>
</div>
